/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 *
 */
export interface IApplyCfg {
  esiaOrgId: any;
}

/**
 *
 */
export interface ICfg {
  base?: string;
  broker?: string;
  host?: string;
  keycloak: any;
  realm?: string;
}

/**
 *
 */
export interface IError {
  code?: string;
  message?: string;
  details?: string;
}

/**
 *
 */
export interface IResult {
  errors: IError[];
  response: any;
  status: boolean;
}

export default ({
  broker = 'esia',
  host,
  keycloak,
  realm,
  base = `${host}/realms/${realm}/broker/${broker}/endpoint`,
}: ICfg) => {
  const path = base + '/organization';

  const apply = async ({ esiaOrgId }: IApplyCfg): Promise<IResult> => {
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${keycloak.token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        esiaOrgId,
        kkUserId: keycloak.idTokenParsed.sub,
      }),
    };

    let result;

    try {
      result = await fetch(path, requestOptions);
      const response = await result.json();

      if (response.status) {
        const refreshed = await keycloak.updateToken(-1);

        if (refreshed) {
          return { errors: [], response: null, status: true };
        } else {
          return {
            errors: response.errors ?? [],
            response: null,
            status: false,
          };
        }
      } else {
        return response as IResult;
      }
    } catch (error) {
      let message;

      if (result?.body) {
        try {
          const body = await result.json();
          message = body.errors?.[0]?.message;
        } catch (err) {
          //
        }
      }

      if (!message) {
        // message: error instanceof Error ? error.message : error?.toString(),
        message = 'Не удалось выполнить запрос.';
      }

      return {
        errors: [{ code: 'req', message }],
        response: null,
        status: false,
      };
    }
  };

  return {
    apply,
  };
};
